<template>
  <div>
    <h1>查詢車隊</h1>
    <Row class="search-group">
      <Col span="5">
        <Input v-model="keyword" suffix="ios-search" placeholder="車隊專屬碼、車隊名稱" style="width: auto" />
      </Col>
      <Button type="primary" @click="serchTeam"><Icon type="md-search" />搜尋</Button>
    </Row>
    <Table stripe border :columns="columns" :no-data-text="noDataText" :data="cooperationTeams"  @on-row-click="showInfo">
    </Table>
  </div>
</template>
<script>
import API from "../asset/js/API"

export default {
  created () {
  },
  data () {
    return {
      cooperationTeams:[],
      columns: [
        {
          title: '專屬碼',
          key: 'code'
        },
        {
          title: '車隊名稱',
          key: 'name'
        },
        {
          title: '客服電話',
          key: 'service_phone',
        },
        {
          title: '客訴電話',
          key: 'phone'
        },
        {
          title: '地址',
          key: 'address'
        },
        {
          title: '動作',
          slot: 'action',
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      // this.isShowPasswordModal = true
                      this.joinCooperationTeam(params.row.id)
                    }
                  }
                },
                "加入"
              )
            ]);
          }
        }
      ],
      noDataText: '暫無資料',
      totalPage: 1,
      keyword: '',
      teamId: null
    }
  },
  methods: {
    serchTeam(){
      API.get(`/taxicooperation/teamlist?kw=${this.keyword}`)
      .then(res => {
        this.cooperationTeams = res.result.list
      })
      .catch(err => {
        console.error('取得車隊列表',err)
      })
    },
    joinCooperationTeam(teamId){
      console.log(teamId)
      API.post('taxicooperation',{
          teamId
      }).then(res => {
        console.log(res)
        if(!res.success) throw new RangeError(res.result)
        this.success('新增成功')
      })
      .catch(err => {
        console.log(err)
        this.failure(err.message)
      })
    },
    success(message){
      this.$Message.success({
        content: message,
        duration: 3,
        closable: true
      });
    },
    failure(message) {
      this.$Message.error({
        content: message,
        duration: 3,
        closable: true
      });
    },
    showInfo(){

    }
  }
}
</script>
<style lang="scss">
@import "@/scss/base.scss";
@import "@/scss/pagination.scss";
button{
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditCooperationTeam.vue